import { render, staticRenderFns } from "./CustomerCaseView.vue?vue&type=template&id=6adcb4fd&scoped=true"
import script from "./CustomerCaseView.vue?vue&type=script&lang=js"
export * from "./CustomerCaseView.vue?vue&type=script&lang=js"
import style0 from "./CustomerCaseView.vue?vue&type=style&index=0&id=6adcb4fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adcb4fd",
  null
  
)

export default component.exports